import { render } from "./FaqLeft.vue?vue&type=template&id=095082cc"
import script from "./FaqLeft.vue?vue&type=script&lang=js"
export * from "./FaqLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__